import React, { useEffect, useState } from "react";
import TreeMapChart2 from "../../CHARTS/TreeMapChart2";
import { colorGenerator } from "../../Utilitie";
const AssetMap = ({ data, second, setTreeMapPath }) => {
  const [chartData, setChartData] = useState(null);
  // utils/transformData.js

  function transformData(input) {
    return input.map((fy) => ({
      name: fy.F_YEAR,
      itemStyle: { color: colorGenerator("default", 3) }, // Use colorGenerator for F_YEAR
      children: fy.children.map((asset) => ({
        name: asset.ASSET_GROUP,
        itemStyle: { color: colorGenerator(asset.ASSET_GROUP, 0) },
        children: asset.children.map((main) => ({
          name: main.MAIN_CAUSE_DESC,
          itemStyle: { color: colorGenerator(asset.ASSET_GROUP, 0) },
          children: main.children.map((sub) => ({
            name: sub.SUB_CAUSE_DESC,
            itemStyle: { color: colorGenerator(asset.ASSET_GROUP, 0) },
            children: sub.children.map((month) => ({
              name: `${month.A_MONTH} (${month.data.length})`,
              value: month.data.length,
              itemStyle: { color: colorGenerator(asset.ASSET_GROUP, 0) },
            })),
          })),
        })),
      })),
    }));
  }

  useEffect(() => {
    if (data) {
      if (data[0] !== null && data[0] !== undefined) {
        if (second) {
          let tempData = transformData([data[1]]);

          setChartData(tempData);
        } else {
          let tempData = transformData([data[0]]);

          setChartData(tempData);
        }
      }
    }
  }, [data]);
  return (
    <div className="">
      <TreeMapChart2 chartData={chartData} setTreeMapPath={setTreeMapPath} />
    </div>
  );
};

export default AssetMap;
